const TrafficConvictionTypeValues = {
    MINOR_CROWDING: 'MINOR_CROWDING',
    MINOR_DEFECTIVE_BRAKES: 'MINOR_DEFECTIVE_BRAKES',
    MINOR_DISTRACTED_DRIVING: 'MINOR_DISTRACTED_DRIVING',
    MINOR_DRIVERS_LICENSE: 'MINOR_DRIVERS_LICENSE',
    MINOR_FAILING_TO_CARRY_INSURANCE: 'MINOR_FAILING_TO_CARRY_INSURANCE',
    MINOR_FAILING_TO_PRODUCE_INSURANCE: 'MINOR_FAILING_TO_PRODUCE_INSURANCE',
    MINOR_FAILING_TO_SHARE: 'MINOR_FAILING_TO_SHARE',
    MINOR_FAILING_TO_SIGNAL: 'MINOR_FAILING_TO_SIGNAL',
    MINOR_SEATBELTS: 'MINOR_SEATBELTS',
    MINOR_FAILING_TO_YIELD: 'MINOR_FAILING_TO_YIELD',
    MINOR_FAILING_TO_YIELD_TO_PEDESTRIAN: 'MINOR_FAILING_TO_YIELD_TO_PEDESTRIAN',
    MINOR_FOLLOW_CLOSELY: 'MINOR_FOLLOW_CLOSELY',
    MINOR_HEADLIGHT_OFFENCES: 'MINOR_HEADLIGHT_OFFENCES',
    MINOR_BUS_LANE: 'MINOR_BUS_LANE',
    MINOR_IMPROPER_LANE_CHANGE: 'MINOR_IMPROPER_LANE_CHANGE',
    MINOR_IMPROPER_OPENING_DOOR: 'MINOR_IMPROPER_OPENING_DOOR',
    MINOR_IMPROPER_PASS: 'MINOR_IMPROPER_PASS',
    MINOR_IMPROPER_TOWING: 'MINOR_IMPROPER_TOWING',
    MINOR_IMPROPER_DIVIDED_HIGHWAY: 'MINOR_IMPROPER_DIVIDED_HIGHWAY',
    MINOR_INSECURE_LOAD: 'MINOR_INSECURE_LOAD',
    MINOR_OTHER: 'MINOR_OTHER',
    MINOR_OBSTRUCTING_TRAFFIC: 'MINOR_OBSTRUCTING_TRAFFIC',
    MINOR_OVERLOADING: 'MINOR_OVERLOADING',
    MINOR_IMPROPER_RAILWAY_CROSSING: 'MINOR_IMPROPER_RAILWAY_CROSSING',
    MINOR_TRAILER_PASSENGER: 'MINOR_TRAILER_PASSENGER',
    MINOR_UNNECESSARY_NOISE: 'MINOR_UNNECESSARY_NOISE',
    MINOR_UNNECESSARY_SLOW_DRIVING: 'MINOR_UNNECESSARY_SLOW_DRIVING',
    MINOR_UNNECESSARY_MOVE: 'MINOR_UNNECESSARY_MOVE',
    MINOR_UNSAFE_TURN: 'MINOR_UNSAFE_TURN',
    MINOR_UNSAFE_VEHICLE: 'MINOR_UNSAFE_VEHICLE',
    MINOR_OBSTRUCTED_VIEW: 'MINOR_OBSTRUCTED_VIEW',
    MINOR_WRONG_WAY: 'MINOR_WRONG_WAY',
    SPEEDING: 'SPEEDING',
    MINOR_STOP_SIGN: 'MINOR_STOP_SIGN',
    MINOR_TRAFFIC_LIGHT: 'MINOR_TRAFFIC_LIGHT',
    MINOR_HAND_HELD_DEVICE_USE: 'MINOR_HAND_HELD_DEVICE_USE',
    MINOR_IMPROPER_TURN: 'MINOR_IMPROPER_TURN',
    MAJOR_CARELESS_DRIVING_ALBERTA: 'MAJOR_CARELESS_DRIVING_ALBERTA',
    MAJOR_FAILING_REPORT_ACCIDENT: 'MAJOR_FAILING_REPORT_ACCIDENT',
    MAJOR_FAILING_REPORT_DAMAGE: 'MAJOR_FAILING_REPORT_DAMAGE',
    MAJOR_FALSE_INSURANCE: 'MAJOR_FALSE_INSURANCE',
    MAJOR_OTHER: 'MAJOR_OTHER',
    MAJOR_UNINSURED: 'MAJOR_UNINSURED',
    MAJOR_FALSE_EVIDENCE_INSURANCE: 'MAJOR_FALSE_EVIDENCE_INSURANCE',
    MAJOR_FAILING_STOP_SCHOOL_BUS: 'MAJOR_FAILING_STOP_SCHOOL_BUS',
    MAJOR_SCHOOL_PLAYGROUND_IMPROPER_PASS: 'MAJOR_SCHOOL_PLAYGROUND_IMPROPER_PASS',
    MAJOR_STUNTING: 'MAJOR_STUNTING',
    MAJOR_RACING_ALBERTA: 'MAJOR_RACING_ALBERTA',
    MAJOR_OWNER_WITHOUT_INSURANCE: 'MAJOR_OWNER_WITHOUT_INSURANCE',
    CRIMINAL_BLOOD_ALCOHOL: 'CRIMINAL_BLOOD_ALCOHOL',
    CRIMINAL_CARELESS_DRIVING_NOT_ALBERTA: 'CRIMINAL_CARELESS_DRIVING_NOT_ALBERTA',
    CRIMINAL_NEGLIGENCE: 'CRIMINAL_NEGLIGENCE',
    CRIMINAL_DANGEROUS_DRIVING: 'CRIMINAL_DANGEROUS_DRIVING',
    CRIMINAL_DRIVING_SUSPENDED: 'CRIMINAL_DRIVING_SUSPENDED',
    CRIMINAL_DRUNK_DRIVING: 'CRIMINAL_DRUNK_DRIVING',
    CRIMINAL_FAILING_OBEY_POLICE: 'CRIMINAL_FAILING_OBEY_POLICE',
    CRIMINAL_FAILING_REMAIN_ACCIDENT: 'CRIMINAL_FAILING_REMAIN_ACCIDENT',
    CRIMINAL_IMPAIRED: 'CRIMINAL_IMPAIRED',
    CRIMINAL_MOTOR_MANSLAUGHTER: 'CRIMINAL_MOTOR_MANSLAUGHTER',
    CRIMINAL_RACING: 'CRIMINAL_RACING',
    CRIMINAL_REFUSE_BREATHALYZER: 'CRIMINAL_REFUSE_BREATHALYZER',
    CRIMINAL_OTHER: 'CRIMINAL_OTHER',
};

export default TrafficConvictionTypeValues;
